// extracted by mini-css-extract-plugin
module.exports = {"Campaign":"Campaign_Campaign__19zDC","Image":"Campaign_Image__2fObt"};